import {
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { formatNumber } from "../../../../../../infrastructure/utils/formatters";
import { ManagementWidgetShell } from "../managementDashboardWidgets";
import { buildDrillDownHref, pick } from "../managementDashboardUtils";

const BUCKET_ORDER = ["Days0To3", "Days4To7", "Days8To14", "DaysOver14"];

const StageAgingMatrix = ({ loading, error, data, onRetry }) => {
  const rows = data?.rows || data?.Rows || [];

  return (
    <ManagementWidgetShell
      title="ماتریس کهنگی مراحل"
      subheader="تعداد درخواست‌های فعال در هر مرحله بر اساس مدت توقف"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      {!rows.length && !loading && !error ? (
        <Typography color="text.secondary">داده‌ای برای نمایش وجود ندارد.</Typography>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>مرحله</TableCell>
                {BUCKET_ORDER.map((code) => {
                  const sample = rows[0]?.buckets?.find(
                    (b) => pick(b, "bucketCode", "BucketCode") === code
                  ) || rows[0]?.Buckets?.find((b) => pick(b, "bucketCode", "BucketCode") === code);
                  return (
                    <TableCell key={code} align="center">
                      {pick(sample, "persianTitle", "PersianTitle") || code}
                    </TableCell>
                  );
                })}
                <TableCell align="center">جمع</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                const stageCode = pick(row, "stageCode", "StageCode");
                const buckets = row.buckets || row.Buckets || [];
                const bucketMap = Object.fromEntries(
                  buckets.map((b) => [pick(b, "bucketCode", "BucketCode"), b])
                );
                const rowDrill = buildDrillDownHref(pick(row, "drillDown", "DrillDown"));

                return (
                  <TableRow key={stageCode} hover>
                    <TableCell>
                      {rowDrill ? (
                        <Link component={RouterLink} to={rowDrill} underline="hover">
                          {pick(row, "persianTitle", "PersianTitle")}
                        </Link>
                      ) : (
                        pick(row, "persianTitle", "PersianTitle")
                      )}
                    </TableCell>
                    {BUCKET_ORDER.map((code) => {
                      const bucket = bucketMap[code];
                      const count = pick(bucket, "count", "Count") ?? 0;
                      const href = buildDrillDownHref(pick(bucket, "drillDown", "DrillDown"));
                      return (
                        <TableCell key={code} align="center">
                          {href && count > 0 ? (
                            <Link component={RouterLink} to={href} underline="hover">
                              {formatNumber(count)}
                            </Link>
                          ) : (
                            formatNumber(count)
                          )}
                        </TableCell>
                      );
                    })}
                    <TableCell align="center" sx={{ fontWeight: 700 }}>
                      {formatNumber(pick(row, "totalCount", "TotalCount") ?? 0)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </ManagementWidgetShell>
  );
};

export default StageAgingMatrix;
